import { Navigate } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";
import { useAppSelector } from "../hooks/useAppSelector";
import { getAccessToken } from "../api/apiClient";
import { ForcePasswordChange } from "./ForcePasswordChange";

interface Props {
    children: React.ReactNode;
}

/**
 * Route-level guard cho mọi page authenticated:
 *   - Không token → /login
 *   - Mật khẩu yếu (must_change_password) → màn hình BUỘC đổi (chặn cả xem lớp)
 *   - Period closed → /closed
 * Check cả Redux state lẫn localStorage để cover trường hợp session restore chưa kịp hydrate.
 */
export const ProtectedRoute = ({ children }: Props) => {
    const { isAuthenticated, mustChangePassword } = useAuth();
    const { periodClosed } = useAppSelector(s => s.queue);
    const hasToken = !!getAccessToken();

    if (!isAuthenticated && !hasToken) {
        return <Navigate to="/login" replace />;
    }
    // Buộc đổi mật khẩu yếu TRƯỚC mọi thứ khác — chặn toàn bộ app (kể cả xem lớp). Server cũng
    // chặn cứng bằng claim pwd_must_change nên có flash cũng không lộ dữ liệu.
    if (mustChangePassword) {
        return <ForcePasswordChange />;
    }
    if (periodClosed) {
        return <Navigate to="/closed" replace />;
    }
    return <>{children}</>;
};
